export default __webpack_public_path__ + "/life-of-riley-by-kevin-macleod-from-filmmusic-io.mp3";